import stringifyJSON from 'fast-json-stable-stringify';
export const stringifyKey = (key) => {
    if (key === undefined) {
        return 'undefined';
    }
    return stringifyJSON(key);
};
//# sourceMappingURL=utils.js.map